module.exports = __webpack_public_path__ + "img/pasos-de-uso-2.38c765e6.svg";